import project1 from "../utils/projects/p1.png";
import project2 from "../utils/projects/p2.png";
import project3 from "../utils/projects/p3.jpg";
import project4 from "../utils/projects/p4.png";
import project5 from "../utils/projects/p5.png";
import project6 from "../utils/projects/p6.jpg";
import project7 from "../utils/projects/p7.png";
import project8 from "../utils/projects/p8.png";

import { FiMonitor } from "react-icons/fi";
import { FaPlus, FaDatabase, FaGamepad, FaMobileAlt } from "react-icons/fa";

export const Bio = {
  name: "Amani Fadli Dokkali",
  roles: [
    "Game Developer",
    "Web Programmer",
    "Java Programmer", 
    "Data Base Programmer", 
    "Programmer"
  ],
  description:
    "I am a student at the Birmingham City University, studying Games Programming. I graduated in Multimedia Applications and Video Game Development, with experience in Web Programming, Databases, Mobile Apps, and Game Development. I am seeking a junior programmer position to apply my skills and enhance the digital experience. I am committed to learning and adapting to the work environment.",
  github: "https://github.com/AmaniFadli",
  resume: require("../utils/projects/Amani-CV.pdf"),
  linkedin: "https://www.linkedin.com/in/amani-fadli-dokkali-81b8172a0/",
  itchio: "https://amanifd.itch.io/",
};

export const skills = [
  {
    title: "GAME DEVELOPMENT",
    icon: <FaGamepad/>,
    subtitle: "Creating immersive gaming experiences.",
    skills: [
      {
        name: "  Unity  ",
        image: "https://w7.pngwing.com/pngs/426/535/png-transparent-unity-new-logo-tech-companies.png",
        text :"Games in Projects",
        progress : 90,
      },
      {
        name: "C#",
        image: "https://www.jetbrains.com/guide/assets/csharp-logo-265a149e.svg",
        text :"Using in Unity ",
        progress : 95,
      },
      {
        name: "Unreal",
        image:
          "https://seeklogo.com/images/U/unreal-engine-logo-12B9A1D996-seeklogo.com.png",
        text :"Small unfinished projects completed during my academic studies",
        progress : 40,
      },
      
      {
        name: "C++",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/1200px-ISO_C%2B%2B_Logo.svg.png",
        text :"Using in Unreal ",
        progress : 30,
      },
    ],
  },
  {
    title: "WEB DEVELOPMENT",
    icon: <FiMonitor/> ,
    subtitle: "Building dynamic websites with modern tools.",
    skills: [
      {
        name: "React Js",
        image:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        text :"I built this website using ReactJS",
        progress : 80,
      },
      {
        name: "Node Js",
        image:
          "https://nodejs.org/static/images/logo.svg",
        text :"Example Proyects in my GitHub",
        progress : 65,
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        text :"Example Proyects in my GitHub",
        progress : 80,
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        text :"Example Proyects in my GitHub",
        progress : 65,
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        text :"Example Proyects in my GitHub",
        progress : 90,
      },
    ],
  },
  {
    title: "MOBILE DEVELOPMENT",
    icon: <FaMobileAlt/>,
    subtitle: "Developing intuitive mobile apps.",
    skills: [
      {
        name: "AndroidStudio",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Android_Studio_Logo_2024.svg/800px-Android_Studio_Logo_2024.svg.png",
        text :"Example Proyects in my GitHub",
        progress : 55,
      },
      {
        name: "Kotlin",
        image:
          "https://cms-assets.tutsplus.com/cdn-cgi/image/width=360/uploads/users/362/posts/29304/preview_image/picKotlin.jpg",
        text :"Example Proyects in my GitHub",
        progress : 50,
      },
    ],
  },
  {
    title: "DATABASE",
    icon: <FaDatabase />,
    subtitle: "Managing data with efficient databases.",
    skills: [
      {
        name: "SQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        text :"Example Proyects in my GitHub",
        progress : 85,
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        text :"Example Proyects in my GitHub",
        progress : 80,
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        text :"Example Proyects in my GitHub",
        progress : 85,
      },
      { 
        name: "Oracle",
        image:
          "https://banner2.cleanpng.com/20180710/vze/aawpmgz55.webp",
        text :"Small unfinished projects completed during my academic studies",
        progress : 60,
      },
    ],
  },
  {
    title: "OTHERS",
    icon: <FaPlus/>,
    subtitle: "Exploring diverse development tools.",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        text :"Prototype in Projects and in my GitHub",
        progress : 95,
      },
      {
        name: "3D Max",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTi_D8rh1f1pabHyt_OEo-mXInBIicX5EKwuw&s",
        text :"Example Proyects in my GitHub",
        progress : 40,
      },
      {
        name: "Blender",
        image:
          "https://i.pcmag.com/imagery/reviews/00CHLsbAPPKloTAg2PZlVBC-1..v1662670755.jpg",
        text :"Small unfinished projects completed during my academic studies and my free time ",
        progress : 40,
      },
      { 
        name: "Photoshop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/800px-Adobe_Photoshop_CC_icon.svg.png",
        text :"Example Pixel Art Proyects in my GitHub",
        progress : 50,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTV8_ibp-PDE6CuOoRKWsbUfVo5-ZfmU6ipXg&s",
    role: "Junior Unity Programmer - Drone Simulator",
    company: "AEROFOR",
    date: "Feb 2024 - Present",
    desc: "Interactive Simulator Development: Created an immersive simulator with realistic physics and detailed environments, offering intuitive controls, training modules, and real-time feedback. Level Design: Designed varied and progressively challenging levels with interactive elements, optimized for efficient performance and an engaging experience. User Management Development: Implemented personalised and secure profiles, with performance analysis tools, customization options, and social features for an enhanced experience.",
    skills: [
     "Unity", 
     "C#", 
     "PlayFab"
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://ncace.ac.uk/wp-content/uploads/2021/01/BCU-logo-stacked_blue.png",
    school: "Birmingham City University, UK",
    date: "Sept 2026 – Present ",
    grade: "Not Yet",
    desc: "Game Word. In this course prepares you to design and develop multiplatform Videogames.",
    degree: "Bachelor of Sciences with Honours - Game Programming",
  },
   {
    id: 1,
    img: "https://aplicar-prod-public.s3.amazonaws.com/uploads/school/logos/cb4a270e-9842-4300-a8fe-33b250375a1c/20231215T110722.263395Z_School_Logo.png",
    school: "University of Bedfordshir, UK",
    date: "Sept 2025 – May 2026 ",
    grade: "A+",
    desc: "FY, Basics on Programmation and Academic Skills",
    degree: "Bachelor of Sciences with Honours - Computer Games Development (with Foundation Year)",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/C4D0BAQGkZ66n1TziFw/company-logo_200_200/company-logo_200_200/0/1630559246814/institut_ausis_march_logo?e=2147483647&v=beta&t=ZmocxYNTLmdW5JOFY8aRYIjcQmTR3sejRkYJxAaVL7o",
    school: "Institut Pedralbes,Barcelona Spain",
    date: "Sept 2022 – Jun 2024 ",
    grade: "8,02",
    desc: "In this course prepares you to design and develop multiplatform video games, as well as web and mobile applications. You’ll learn programming, databases, and how to use game engines like Unity or Unreal Engine to create 2D/3D environments, gameplay mechanics, and artificial intelligence. Additionally, you’ll work on web and mobile app development, gaining versatile skills. The course includes a final project (a fully developed video game or application) and internships in the tech industry, making it the perfect mix of creativity and programming to thrive in gaming, web, and mobile development.",
    degree: "HNC in Development of Muliplatform Apps & Videogame (DAM-VI)",
  },
  {
    id: 3,
    img: "https://pbs.twimg.com/media/GXDQfkgX0AEmCTM.jpg",
    school:"Institut Isaac Albeniz, Badalona, Spain ",
    date: "Sept 2020 – May 2022 ",
    grade: "5,69",
    desc: "Research Project: “ Jupiter: An Impossible Star “, based on the study of the formation, composition and impact of Jupiter on the Solar System and the potential of a binary system by programming a simulation. ",
    degree: "Spanish Baccalaureate in Technology",
  },
  
];

export const projects = [
  {
    id: 9,
    title: "DAL(IA)",
    description:
      "My classmates, our tutor, and I participated in 'Premios Transferencia de conocimiento de la FP'. This competition addresses societal issues aligned with the Sustainable Development Goals (SDGs), focusing on Goal 5 (gender equality) and also relating to Goals 3, 4, 9, and 10. We identified the growing issue of digital gender-based violence, which needs innovative solutions. Detecting these patterns in conversations can be challenging. Our solution is DALIA, a mobile app using AI to recognize verbal violence through patterns, words, and phrases in conversations. It also includes behavior analysis tests to help users become more aware of their communication.",
    image: project1,
    tags: [
      "Java", 
      "VisualStudio", 
      "JSON"
    ],
    category: "prototype",
    webapp: "https://www.youtube.com/watch?v=N1rjROAsX2Y&t=1s",
    member: [
      {
        name: "Alma Colina",
        img: "https://img.freepik.com/vector-premium/icono-perfil-usuario-estilo-plano-ilustracion-vector-avatar-miembro-sobre-fondo-aislado-concepto-negocio-signo-permiso-humano_157943-15752.jpg",
        linkedin: "https://www.linkedin.com/in/almacolina/",
      },
      {
        name: "Emma Casadevall Hernández",
        img: "https://img.freepik.com/vector-premium/icono-perfil-usuario-estilo-plano-ilustracion-vector-avatar-miembro-sobre-fondo-aislado-concepto-negocio-signo-permiso-humano_157943-15752.jpg",
        linkedin: "https://www.linkedin.com/in/emma-casadevall-hern%C3%A1ndez-362a85226/",
      },
      {
        name: "Laura Carrillo Espigares",
        img: "https://img.freepik.com/vector-premium/icono-perfil-usuario-estilo-plano-ilustracion-vector-avatar-miembro-sobre-fondo-aislado-concepto-negocio-signo-permiso-humano_157943-15752.jpg",
        linkedin: "https://www.linkedin.com/in/lcarrilloe/",
      },
      {
        name: "Clàudia Martín",
        img: "https://img.freepik.com/vector-premium/icono-perfil-usuario-estilo-plano-ilustracion-vector-avatar-miembro-sobre-fondo-aislado-concepto-negocio-signo-permiso-humano_157943-15752.jpg",
        linkedin: "https://www.linkedin.com/in/cl%C3%A0udia-mart%C3%ADn-993933226/",
      },
      {
        name: "Amani Fadli Dokkali",
        img: "",
        linkedin: "https://www.linkedin.com/in/amani-fadli-dokkali-81b8172a0/",
        github: "",
      },

    ],
  },
  {
    id: 0,
    title: "HOLLYWOOD NIGHTMARE",
    date: "Des 2023 - May 2024",
    description:
      "Welcome to Hollywood Nightmare! Join a mother and daughter on an epic adventure in a Barcelona movie studio where film characters come to life. Battle across three sets: Barbie, Star Wars, and The Matrix. With a unique visual style blending retro and avant-garde, Hollywood Nightmare offers action, fun, and a feminist twist. Available on Xbox, PlayStation, PC/MAC, and mobile devices.",
    image: project2,
    tags: ["Unity", "C#", "Blender", "FMod"],
    category: "games",
    webapp: "https://amanifd.itch.io/hollywood-nightmare",
  },
  {
    id: 1,
    title: "FINAL MISSION",

    description:
      "It's a first-person 3D Escape Room game, where players must solve a series of puzzles and riddles in order to 'escape' from a themed room or environment within a limited time.",
    image:project3,
    tags: ["Unity", "C#"],
    category: "games",
    webapp: "https://amanifd.itch.io/final-mission",
  },
  {
    id: 2,
    title: "UNFORESEEN",
    date: "Jan 2023 - Mar 2023",
    description:
      "Dive into an unforgettable adventure with our game, a perfect blend of 3D enviroment and charming 2D pixel art. Navigate a dark dungeon, relying on your skills and powers to uncover the hidden treasure. This game had its genesis during one of the JAM sponsored by FX BARCELONA FILM SCHOOL. The JAM focused on creating a game in just two days, following the theme of 'Into the unknown'. We are very happy and satisfied, as we achieved first place for the best game in the Jam. It was an enjoyable and ambitious experience thanks to FX Barcelona Film School.",
    image: project4,
    tags: ["Unity", "C#", "Blender", "Photoshop"],
    category: "games",
    webapp: "https://amanifd.itch.io/unforeseen",
    member: [
      {
        name: "Guillem Sanchez Parra (Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/guillem-sanchez-parra-820551294/",
        github: "",
      },
      {
        name: "Pol Rodríguez Melero (Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/pol-rodr%C3%ADguez-melero-633b38294/",
        github: "https://github.com/Tihersarc",
      },
      {
        name: "Joel Prados Zurita (3D Art)",
        img: "",
        linkedin: "https://www.linkedin.com/in/joel-prados-zurita-620aa9282/",
        github: "https://github.com/Tihersarc",
      },
      {
        name: "Amani Fadli Dokkali (Programmer & PixelArt)",
        img: "",
        linkedin: "https://www.linkedin.com/in/amani-fadli-dokkali-81b8172a0/",
        github: "",
      },
    ],
  },
  {
    id: 3,
    title: "THE GRAVEKEEPER",
    description:
      "Experience 'The Gravekeeper' a horror game where cleaning tombs turns into a survival challenge. As a cemetery worker, you'll face unique ghosts with specific rules. Clean in the right order to earn their trust and uncover their stories—or risk their wrath. Can you navigate the darkness and escape their vengeance?",
    image:project7,
    tags: ["Unity", "C#", "Blender", "Photoshop"],
    category: "games",
    webapp: "https://sttrangge.itch.io/the-gravekeeper",
  },
  {
    id: 10,
    title: "ESCAPE TO THE DEPTH",
    description:
      "In 'Escape the Depth' the player is trapped in a deep underground well and must overcome challenging parkour courses to escape. Developed in 3D using the Unity engine, this game tests your agility and precision. With each jump, climb, and sprint, the risk is high: one mistake could lead you to fall into the abyss. This game had its genesis during one of the JAM sponsored by FRAME GAMES. The JAM focused on creating a game in just two days, following the theme of 'deep'. I am very proud to have participated with my teammates and for the pleasant experience provided by Frame Games, even though we didn't win anything",
    image:project5,
    tags: ["Unity", "C#", "Blender", "Photoshop"],
    category: "games",
    webapp: "https://sttrangge.itch.io/escape-the-depth",
    member: [
      {
        name: "Guillem Sanchez Parra (Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/guillem-sanchez-parra-820551294/",
        github: "",
      },
      {
        name: "Asmae Charroud Benaisni (UI)",
        img: "",
        linkedin: "https://www.linkedin.com/in/asmae-c-3a10b2255/",
        github: "",
      },
      {
        name: "Joel Prados Zurita (3D Art)",
        img: "",
        linkedin: "https://www.linkedin.com/in/joel-prados-zurita-620aa9282/",
        github: "",
      },
      {
        name: "Carlos Abril Salguero (3D Art)",
        img: "",
        linkedin: "https://www.linkedin.com/in/carlos-abril-salguero-2074b0254/",
        github: "",
      },
      {
        name: "Amani Fadli Dokkali (Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/amani-fadli-dokkali-81b8172a0/",
        github: "",
      },
    ],
  },
  {
    id: 4,
    title: "COZY CUP",
    description:
      "It's a 3D game made with the Unity engine. This game had its genesis during one of the JAMS sponsored by Itch.io. The JAM in question was conducted during Winter MelonJam 2023 and focused on creating a game in just two days, following the theme of charm. In this challenge, I collaborated with three colleagues, and our participation was framed in the category of beginners/students.",
    image:project6,
    tags: ["Unity", "C#", "Blender", "Photoshop"],
    category: "games",
    webapp: "https://sttrangge.itch.io/cozy-cup",
    member: [
      {
        name: "Asmae Charroud Benaisni (UI & Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/asmae-c-3a10b2255/",
        github: "",
      },
      {
        name: "Eric Alvarez Fernandez (3D Art)",
        img: "",
        linkedin: "https://www.linkedin.com/in/eric-alvarez-fernandez-39bb52178/",
        github: "",
      },
      {
        name: "Naim Ladid (3D Art)",
        img: "",
        linkedin: "https://www.linkedin.com/in/naim-ladid-6a600b245/",
        github: "",
      },
      {
        name: "Amani Fadli Dokkali (Programmer)",
        img: "",
        linkedin: "https://www.linkedin.com/in/amani-fadli-dokkali-81b8172a0/",
        github: "",
      },
    ],
  },
  {
    id: 5,
    title: "MY WEBSITE",
    description:
      "This website is made to show my work and my experience in the different areas of programming.",
    image:project8,
    tags: ["ReactJs", "CSS", "HTML"],
    category: "react",
    webapp: "https://amani-fadli.vercel.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
